import { render } from "./selectPack.vue?vue&type=template&id=44cccf6e"
import script from "./selectPack.vue?vue&type=script&lang=js"
export * from "./selectPack.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\甘小星\\Desktop\\sakai-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__